var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgDelete(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 41,
    viewBox: "0 0 30 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5156 10.0898L20.1562 1.52148C19.2188 0.560547 17.9688 0 16.6406 0H5C2.1875 0 0 2.32227 0 5.125V35.875C0 38.7578 2.1875 41 5 41H25C27.7344 41 30 38.7578 30 35.875V13.6934C30 12.332 29.4531 11.0508 28.5156 10.0898ZM17.5 2.80273C17.8125 2.88281 18.125 3.04297 18.4375 3.36328L26.7188 11.8516C27.0312 12.1719 27.1875 12.4922 27.2656 12.8125H18.75C18.0469 12.8125 17.5 12.252 17.5 11.5312V2.80273ZM27.5 35.875C27.5 37.3164 26.3281 38.4375 25 38.4375H5C3.59375 38.4375 2.5 37.3164 2.5 35.875V5.125C2.5 3.76367 3.59375 2.5625 5 2.5625H15V11.5312C15 13.6934 16.6406 15.375 18.75 15.375H27.5V35.875ZM10.8594 20.9004C10.3906 20.4199 9.53125 20.4199 9.0625 20.9004C8.59375 21.3809 8.59375 22.2617 9.0625 22.7422L13.2031 26.9062L9.0625 31.1504C8.59375 31.6309 8.59375 32.5117 9.0625 32.9922C9.53125 33.4727 10.3906 33.4727 10.8594 32.9922L15 28.748L19.0625 32.9922C19.5312 33.4727 20.3906 33.4727 20.8594 32.9922C21.3281 32.5117 21.3281 31.6309 20.8594 31.1504L16.7188 26.9062L20.8594 22.7422C21.3281 22.2617 21.3281 21.3809 20.8594 20.9004C20.3906 20.4199 19.5312 20.4199 19.0625 20.9004L15 25.1445L10.8594 20.9004Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDelete);
export default __webpack_public_path__ + "static/media/img_delete.7c687ec063f4a0c03f4dbfe01982ae2f.svg";
export { ForwardRef as ReactComponent };